import React, { useState, useEffect } from 'react';
import { Button, App } from 'antd';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import styles from './LiveEnded.module.scss';
//import videourl from '@/assets/videos/1.mp4';

/**
 * LiveEnded 组件 - 直播结束后的数据统计页面
 * 显示直播数据统计和回放视频
 */
const LiveEnded: React.FC = () => {
  // 使用 Redux dispatch 和 Antd message hook
  const dispatch = useAppDispatch();
  const { message } = App.useApp();

  // 直播数据
  const liveData = {
    time: '07/03/2025 14:00:00',
    duration: '01:25:51',
    totalViewers: '30,000',
    avgOnlineViewers: '9,000',
    newFollowers: '2,000',
    orderQuantity: '100',
    likeCount: '1,000,000',
    broadcastDuration: '01:25:51',
    violationCount: '0',
    refundCount: '0',
    giftCount: '200',
    giftAmount: '3,500',
    inventory: '1,000',
    avgStayDuration: '00:18:30'
  };

  //mounted 和unmounted
  useEffect(() => {

  }, []);

  return (
    <div className={styles['live-ended-container']}>
      <div className={styles['title']}>
        Townloop Live
      </div>

      <div className={styles['broadcast-info']}>
        <div className={styles['broadcast-header']}>
          <span className={styles['broadcast-label']}>Live Broadcast Data</span>
          <span className={styles['broadcast-time']}>Time: {liveData.time}</span>
          <span className={styles['broadcast-duration']}>Broadcast Duration: <span className={styles['duration-highlight']}>{liveData.duration}</span></span>
        </div>
      </div>

      <div className={styles['stats-container']}>
        <div className={styles['stats-grid']}>
          <div className={styles['stat-item']}>
            <div className={styles['stat-label']}>Total Viewers</div>
            <div className={styles['stat-value']}>{liveData.totalViewers}</div>
          </div>
          <div className={styles['stat-item']}>
            <div className={styles['stat-label']}>Average Online Viewers</div>
            <div className={styles['stat-value']}>{liveData.avgOnlineViewers}</div>
          </div>
          <div className={styles['stat-item']}>
            <div className={styles['stat-label']}>New Followers</div>
            <div className={styles['stat-value']}>{liveData.newFollowers}</div>
          </div>
          <div className={styles['stat-item']}>
            <div className={styles['stat-label']}>Order Quantity</div>
            <div className={styles['stat-value']}>{liveData.orderQuantity}</div>
          </div>
          <div className={styles['stat-item']}>
            <div className={styles['stat-label']}>Like Count</div>
            <div className={styles['stat-value']}>{liveData.likeCount}</div>
          </div>
          <div className={styles['stat-item']}>
            <div className={styles['stat-label']}>Broadcast Duration</div>
            <div className={styles['stat-value']}>{liveData.broadcastDuration}</div>
          </div>
        </div>

        <div className={`${styles['stats-grid']} ${styles['stats-grid-second']}`}>
          <div className={styles['stat-item']}>
            <div className={styles['stat-label']}>Violation Count</div>
            <div className={styles['stat-value']}>{liveData.violationCount}</div>
          </div>
          <div className={styles['stat-item']}>
            <div className={styles['stat-label']}>Refund Count</div>
            <div className={styles['stat-value']}>{liveData.refundCount}</div>
          </div>
          <div className={styles['stat-item']}>
            <div className={styles['stat-label']}>Gift Count</div>
            <div className={styles['stat-value']}>{liveData.giftCount}</div>
          </div>
          <div className={styles['stat-item']}>
            <div className={styles['stat-label']}>Gift Amount($)</div>
            <div className={styles['stat-value']}>{liveData.giftAmount}</div>
          </div>
          <div className={styles['stat-item']}>
            <div className={styles['stat-label']}>Inventory</div>
            <div className={styles['stat-value']}>{liveData.inventory}</div>
          </div>
          <div className={styles['stat-item']}>
            <div className={styles['stat-label']}>Avg. Stay Duration</div>
            <div className={styles['stat-value']}>{liveData.avgStayDuration}</div>
          </div>
        </div>
      </div>

      <div className={styles['replay-section']}>
        <div className={styles['replay-header']}>
          <span className={styles['replay-title']}>Live Replay</span>
          <Button className={styles['save-button']} type="link">Save</Button>
        </div>

        <div className={styles['video-container']}>
          <div className='video-item'>
            <video
              className={styles['video-player']}
              controls
              poster="/api/placeholder/400/300"
            >
              {/* <source src={videourl} type="video/mp4" /> */}
              您的浏览器不支持视频播放。
            </video>
            <div className={styles['video-info']}>
              <div className='flex justify-between mb-[8px] items-center'>
                <div className={styles['video-title']}>Basket Bonanza</div>
                <div className={styles['video-date']}>07/03/2025 14:00:00</div>
              </div>
              
              <div className={styles['video-description']}>
                Shape Classification: Square Handheld Wicker Basket
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  );
};

export default LiveEnded;

